import * as Yup from "yup";
import { nameFieldValidation, phoneNumberRequiredValidation } from "common/utils/validationHelpers";

export const candidateValidationSchema = Yup.object().shape({
  name: nameFieldValidation("Name", true),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: phoneNumberRequiredValidation(),
  city: Yup.string(),
  state: Yup.string(),
  experienceRange: Yup.string().required("Experience range is required"),

  highestQualification: Yup.string().required("Qualification is required")
    .test(
      "check-custom-other",
      "Please enter a custom highest qualification",
      function (value) {
        const { customHighestQualification } = this.parent;
        if (value === "Other") {
          return (
            customHighestQualification &&
            customHighestQualification.trim() !== ""
          );
        }
        return true; // valid for all other values
      }
    ),
  customHighestQualification: Yup.string(),
  currentJobTitle: Yup.string()
    .test(
      "check-custom-other",
      "Please enter a custom job title",
      function (value) {
        const { customJobTitle } = this.parent;
        if (value === "Other") {
          return customJobTitle && customJobTitle.trim() !== "";
        }
        return true; // valid for all other values
      }
    ),
  customJobTitle: Yup.string(),

  currentEmployer: Yup.string().required("Current employer is required"),

  skills: Yup.array()
    .compact() // removes empty or undefined values
    .min(1, "At least one skill is required")
    .required("Skills are required"),
  customSkill: Yup.string().when("skills", {
    is: (skills) => skills && skills.includes("Other"),
    then: (schema) => schema.required("Please enter custom skill"),
    otherwise: (schema) => schema.notRequired(),
  }),

  status: Yup.string().required("Status is required"),
  noticePeriod: Yup.string(),
  source: Yup.string()
    .required("Source is required")
    .test(
      "check-custom-other",
      "Please enter a custom source",
      function (value) {
        const { customSource } = this.parent; // get sibling field
        if (value === "Other") {
          return customSource && customSource.trim() !== "";
        }
        return true; // valid for all other values
      }
    ),
  customSource: Yup.string(),
  owner: Yup.string().required("Owner is required"), // assuming ID comes as string
  resume: Yup.string(),
  coverLetter: Yup.string().nullable(), // optional field
  lastWorkingDate: Yup.date()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === "" ? null : value
    )
  ,

  currentCTC: Yup.string()
    .matches(/^\d{1,2}(\.\d{0,2})?$/, "Current CTC must be in LPA with max 2 digits before decimal")
    .test("is-valid-ctc", "Current CTC cannot be negative", value => !value || parseFloat(value) >= 0),

  expectedCTC: Yup.string()
    .matches(/^\d{1,2}(\.\d{0,2})?$/, "Expected CTC must be in LPA (e.g., 12.34) with max 2 digits before decimal")
    .test("is-valid-ctc", "Expected CTC cannot be negative", value => !value || parseFloat(value) >= 0),
});
